import { modelsDir } from './config';

const stagesInfo = [
  {
    id: 0,
    name: 'stage1',
    top_lead: require('@/assets/images/stage1/lead_stage.png'),
    top_subject: require('@/assets/images/stage1/tit_stage.png'),
    top_text: require('@/assets/images/stage1/txt_stage.png'),
    top_image: require('@/assets/images/stage1/img_target_stage.png'),
    top_border: require('@/assets/images/stage1/border.png'),
    btn_start: require('@/assets/images/stage/button_start_1.png'),
    start_text: require('@/assets/images/stage/button_start_1.png'),
    finished_text: require('@/assets/images/stage/shuryo_1.png'),
    play_text_time: require('@/assets/images/stage/stage1_time.png'),
    play_text_target: require('@/assets/images/stage/stage1_target.png'),
    play_count_symbol: require('@/assets/images/stage/count_symbol1.png'),
    play_time_count: [
      require('@/assets/images/stage/number_stage1_0.png'),
      require('@/assets/images/stage/number_stage1_1.png'),
      require('@/assets/images/stage/number_stage1_2.png'),
      require('@/assets/images/stage/number_stage1_3.png'),
      require('@/assets/images/stage/number_stage1_4.png'),
      require('@/assets/images/stage/number_stage1_5.png'),
      require('@/assets/images/stage/number_stage1_6.png'),
      require('@/assets/images/stage/number_stage1_7.png'),
      require('@/assets/images/stage/number_stage1_8.png'),
      require('@/assets/images/stage/number_stage1_9.png'),
      require('@/assets/images/stage/number_stage1_10.png'),
      require('@/assets/images/stage/number_stage1_11.png'),
      require('@/assets/images/stage/number_stage1_12.png'),
      require('@/assets/images/stage/number_stage1_13.png'),
      require('@/assets/images/stage/number_stage1_14.png'),
      require('@/assets/images/stage/number_stage1_15.png'),
      require('@/assets/images/stage/number_stage1_16.png'),
      require('@/assets/images/stage/number_stage1_17.png'),
      require('@/assets/images/stage/number_stage1_18.png'),
      require('@/assets/images/stage/number_stage1_19.png'),
      require('@/assets/images/stage/number_stage1_20.png'),
      require('@/assets/images/stage/number_stage1_21.png'),
      require('@/assets/images/stage/number_stage1_22.png'),
      require('@/assets/images/stage/number_stage1_23.png'),
      require('@/assets/images/stage/number_stage1_24.png'),
      require('@/assets/images/stage/number_stage1_25.png'),
      require('@/assets/images/stage/number_stage1_26.png'),
      require('@/assets/images/stage/number_stage1_27.png'),
      require('@/assets/images/stage/number_stage1_28.png'),
      require('@/assets/images/stage/number_stage1_29.png'),
      require('@/assets/images/stage/number_stage1_30.png'),
    ],
    end_text_get_microbe: require('@/assets/images/stage1/txt_get_microbe.png'),
    btn_replay: require('@/assets/images/stage/button_replay_1.png'),
    btn_picture_book: require('@/assets/images/stage/button_zukan_1.png'),
    btn_exit: require('@/assets/images/stage/button_exit_1.png'),
    target_microbes: ['koji', 'sakusan', 'akkermansia', 'salmonella', 'rhodotorula'],
    correct_microbes: ['koji', 'sakusan'],
    incorrect_microbes: ['akkermansia', 'salmonella', 'rhodotorula'],
    title: '発酵ハンター',
    title_image_path: require('@/assets/images/stage/biseibutsu_icon_21.png'),
    title_image_lock_path: require('@/assets/images/stage/biseibutsu_icon_lock_21.png'),
    incorrect_title: 'もの好きハンター',
    incorrect_title_image_path: require('@/assets/images/stage/biseibutsu_icon_25.png'),
    incorrect_title_lock_image_path: require('@/assets/images/stage/biseibutsu_icon_lock_25.png'),
    models_path: [
      modelsDir + 'stage/stage1_1.gltf'
    ],
    font_color: '#F48100',
  },
  {
    id: 1,
    name: 'stage2',
    top_lead: require('@/assets/images/stage2/lead_stage.png'),
    top_subject: require('@/assets/images/stage2/tit_stage.png'),
    top_text: require('@/assets/images/stage2/txt_stage.png'),
    top_image: require('@/assets/images/stage2/img_target_stage.png'),
    top_border: require('@/assets/images/stage2/border.png'),
    btn_start: require('@/assets/images/stage/button_start_2.png'),
    start_text: require('@/assets/images/stage/button_start_2.png'),
    finished_text: require('@/assets/images/stage/shuryo_2.png'),
    play_text_time: require('@/assets/images/stage/stage2_time.png'),
    play_text_target: require('@/assets/images/stage/stage2_target.png'),
    play_count_symbol: require('@/assets/images/stage/count_symbol2.png'),
    play_time_count: [
      require('@/assets/images/stage/number_stage2_0.png'),
      require('@/assets/images/stage/number_stage2_1.png'),
      require('@/assets/images/stage/number_stage2_2.png'),
      require('@/assets/images/stage/number_stage2_3.png'),
      require('@/assets/images/stage/number_stage2_4.png'),
      require('@/assets/images/stage/number_stage2_5.png'),
      require('@/assets/images/stage/number_stage2_6.png'),
      require('@/assets/images/stage/number_stage2_7.png'),
      require('@/assets/images/stage/number_stage2_8.png'),
      require('@/assets/images/stage/number_stage2_9.png'),
      require('@/assets/images/stage/number_stage2_10.png'),
      require('@/assets/images/stage/number_stage2_11.png'),
      require('@/assets/images/stage/number_stage2_12.png'),
      require('@/assets/images/stage/number_stage2_13.png'),
      require('@/assets/images/stage/number_stage2_14.png'),
      require('@/assets/images/stage/number_stage2_15.png'),
      require('@/assets/images/stage/number_stage2_16.png'),
      require('@/assets/images/stage/number_stage2_17.png'),
      require('@/assets/images/stage/number_stage2_18.png'),
      require('@/assets/images/stage/number_stage2_19.png'),
      require('@/assets/images/stage/number_stage2_20.png'),
      require('@/assets/images/stage/number_stage2_21.png'),
      require('@/assets/images/stage/number_stage2_22.png'),
      require('@/assets/images/stage/number_stage2_23.png'),
      require('@/assets/images/stage/number_stage2_24.png'),
      require('@/assets/images/stage/number_stage2_25.png'),
      require('@/assets/images/stage/number_stage2_26.png'),
      require('@/assets/images/stage/number_stage2_27.png'),
      require('@/assets/images/stage/number_stage2_28.png'),
      require('@/assets/images/stage/number_stage2_29.png'),
      require('@/assets/images/stage/number_stage2_30.png'),
    ],
    end_text_get_microbe: require('@/assets/images/stage2/txt_get_microbe.png'),
    btn_replay: require('@/assets/images/stage/button_replay_2.png'),
    btn_picture_book: require('@/assets/images/stage/button_zukan_2.png'),
    btn_exit: require('@/assets/images/stage/button_exit_2.png'),
    target_microbes: ['hosya', 'penicillium', 'euglena', 'pankobo', 'kaentake'],
    correct_microbes: ['hosya', 'penicillium'],
    incorrect_microbes: ['euglena', 'pankobo', 'kaentake'],
    title: 'ドクターハンター',
    title_image_path: require('@/assets/images/stage/biseibutsu_icon_22.png'),
    title_image_lock_path: require('@/assets/images/stage/biseibutsu_icon_lock_22.png'),
    incorrect_title: '骨おりぞんハンター',
    incorrect_title_image_path: require('@/assets/images/stage/biseibutsu_icon_26.png'),
    incorrect_title_lock_image_path: require('@/assets/images/stage/biseibutsu_icon_lock_26.png'),
    models_path: [
      modelsDir + 'stage/stage2_3.gltf'
    ],
    font_color: '#6AE200',
  },
  {
    id: 2,
    name: 'stage3',
    top_lead: require('@/assets/images/stage3/lead_stage.png'),
    top_subject: require('@/assets/images/stage3/tit_stage.png'),
    top_text: require('@/assets/images/stage3/txt_stage.png'),
    top_image: require('@/assets/images/stage3/img_target_stage.png'),
    top_border: require('@/assets/images/stage3/border.png'),
    btn_start: require('@/assets/images/stage/button_start_3.png'),
    start_text: require('@/assets/images/stage/button_start_3.png'),
    finished_text: require('@/assets/images/stage/shuryo_3.png'),
    play_text_time: require('@/assets/images/stage/stage3_time.png'),
    play_text_target: require('@/assets/images/stage/stage3_target.png'),
    play_count_symbol: require('@/assets/images/stage/count_symbol3.png'),
    play_time_count: [
      require('@/assets/images/stage/number_stage3_0.png'),
      require('@/assets/images/stage/number_stage3_1.png'),
      require('@/assets/images/stage/number_stage3_2.png'),
      require('@/assets/images/stage/number_stage3_3.png'),
      require('@/assets/images/stage/number_stage3_4.png'),
      require('@/assets/images/stage/number_stage3_5.png'),
      require('@/assets/images/stage/number_stage3_6.png'),
      require('@/assets/images/stage/number_stage3_7.png'),
      require('@/assets/images/stage/number_stage3_8.png'),
      require('@/assets/images/stage/number_stage3_9.png'),
      require('@/assets/images/stage/number_stage3_10.png'),
      require('@/assets/images/stage/number_stage3_11.png'),
      require('@/assets/images/stage/number_stage3_12.png'),
      require('@/assets/images/stage/number_stage3_13.png'),
      require('@/assets/images/stage/number_stage3_14.png'),
      require('@/assets/images/stage/number_stage3_15.png'),
      require('@/assets/images/stage/number_stage3_16.png'),
      require('@/assets/images/stage/number_stage3_17.png'),
      require('@/assets/images/stage/number_stage3_18.png'),
      require('@/assets/images/stage/number_stage3_19.png'),
      require('@/assets/images/stage/number_stage3_20.png'),
      require('@/assets/images/stage/number_stage3_21.png'),
      require('@/assets/images/stage/number_stage3_22.png'),
      require('@/assets/images/stage/number_stage3_23.png'),
      require('@/assets/images/stage/number_stage3_24.png'),
      require('@/assets/images/stage/number_stage3_25.png'),
      require('@/assets/images/stage/number_stage3_26.png'),
      require('@/assets/images/stage/number_stage3_27.png'),
      require('@/assets/images/stage/number_stage3_28.png'),
      require('@/assets/images/stage/number_stage3_29.png'),
      require('@/assets/images/stage/number_stage3_30.png'),
    ],
    end_text_get_microbe: require('@/assets/images/stage3/txt_get_microbe.png'),
    btn_replay: require('@/assets/images/stage/button_replay_3.png'),
    btn_picture_book: require('@/assets/images/stage/button_zukan_3.png'),
    btn_exit: require('@/assets/images/stage/button_exit_3.png'),
    target_microbes: ['suiso', 'labyrinthulea', 'volvox', 'thermus', 'nyusan'],
    correct_microbes: ['suiso', 'labyrinthulea'],
    incorrect_microbes: ['volvox', 'thermus', 'nyusan'],
    title: 'エコロジーハンター',
    title_image_path: require('@/assets/images/stage/biseibutsu_icon_23.png'),
    title_image_lock_path: require('@/assets/images/stage/biseibutsu_icon_lock_23.png'),
    incorrect_title: 'ふうがわりハンター',
    incorrect_title_image_path: require('@/assets/images/stage/biseibutsu_icon_27.png'),
    incorrect_title_lock_image_path: require('@/assets/images/stage/biseibutsu_icon_lock_27.png'),
    models_path: [
      modelsDir + 'stage/stage3_2.gltf'
    ],
    font_color: '#005EFF',
  },
  {
    id: 3,
    name: 'stage4',
    top_lead: require('@/assets/images/stage4/lead_stage.png'),
    top_subject: require('@/assets/images/stage4/tit_stage.png'),
    top_text: require('@/assets/images/stage4/txt_stage.png'),
    top_image: require('@/assets/images/stage4/img_target_stage.png'),
    top_border: require('@/assets/images/stage4/border.png'),
    btn_start: require('@/assets/images/stage/button_start_4.png'),
    start_text: require('@/assets/images/stage/button_start_4.png'),
    finished_text: require('@/assets/images/stage/shuryo_4.png'),
    play_text_time: require('@/assets/images/stage/stage4_time.png'),
    play_text_target: require('@/assets/images/stage/stage4_target.png'),
    play_count_symbol: require('@/assets/images/stage/count_symbol4.png'),
    play_time_count: [
      require('@/assets/images/stage/number_stage4_0.png'),
      require('@/assets/images/stage/number_stage4_1.png'),
      require('@/assets/images/stage/number_stage4_2.png'),
      require('@/assets/images/stage/number_stage4_3.png'),
      require('@/assets/images/stage/number_stage4_4.png'),
      require('@/assets/images/stage/number_stage4_5.png'),
      require('@/assets/images/stage/number_stage4_6.png'),
      require('@/assets/images/stage/number_stage4_7.png'),
      require('@/assets/images/stage/number_stage4_8.png'),
      require('@/assets/images/stage/number_stage4_9.png'),
      require('@/assets/images/stage/number_stage4_10.png'),
      require('@/assets/images/stage/number_stage4_11.png'),
      require('@/assets/images/stage/number_stage4_12.png'),
      require('@/assets/images/stage/number_stage4_13.png'),
      require('@/assets/images/stage/number_stage4_14.png'),
      require('@/assets/images/stage/number_stage4_15.png'),
      require('@/assets/images/stage/number_stage4_16.png'),
      require('@/assets/images/stage/number_stage4_17.png'),
      require('@/assets/images/stage/number_stage4_18.png'),
      require('@/assets/images/stage/number_stage4_19.png'),
      require('@/assets/images/stage/number_stage4_20.png'),
      require('@/assets/images/stage/number_stage4_21.png'),
      require('@/assets/images/stage/number_stage4_22.png'),
      require('@/assets/images/stage/number_stage4_23.png'),
      require('@/assets/images/stage/number_stage4_24.png'),
      require('@/assets/images/stage/number_stage4_25.png'),
      require('@/assets/images/stage/number_stage4_26.png'),
      require('@/assets/images/stage/number_stage4_27.png'),
      require('@/assets/images/stage/number_stage4_28.png'),
      require('@/assets/images/stage/number_stage4_29.png'),
      require('@/assets/images/stage/number_stage4_30.png'),
    ],
    end_text_get_microbe: require('@/assets/images/stage4/txt_get_microbe.png'),
    btn_replay: require('@/assets/images/stage/button_replay_4.png'),
    btn_picture_book: require('@/assets/images/stage/button_zukan_4.png'),
    btn_exit: require('@/assets/images/stage/button_exit_4.png'),
    target_microbes: ['ideonella', 'dehalococcoides', 'jisei', 'methane', 'natto'],
    correct_microbes: ['ideonella', 'dehalococcoides'],
    incorrect_microbes: ['jisei', 'methane', 'natto'],
    title: '環境保護ハンター',
    title_image_path: require('@/assets/images/stage/biseibutsu_icon_24.png'),
    title_image_lock_path: require('@/assets/images/stage/biseibutsu_icon_lock_24.png'),
    incorrect_title: 'きまぐれハンター',
    incorrect_title_image_path: require('@/assets/images/stage/biseibutsu_icon_28.png'),
    incorrect_title_lock_image_path: require('@/assets/images/stage/biseibutsu_icon_lock_28.png'),
    models_path: [
      modelsDir + 'stage/stage4_1.gltf'
    ],
    font_color: '#A150D0',
  },
]

export { stagesInfo };